import axios from 'axios';

const KNOWN_ERROR_CODES = [
  'UNAUTHORIZED',
  'FORBIDDEN',
  'NOT_FOUND',
  'VALIDATION_ERROR',
  'SERVER_ERROR',
] as const;

function buildErrorCodeTranslationKey(errorCode: string): string {
  return 'errors:byCode.' + errorCode;
}

function readBackendErrorCode(responseData: unknown): string {
  if (responseData === null || typeof responseData !== 'object') {
    return '';
  }
  const candidateCode = (responseData as Record<string, unknown>).code;
  if (typeof candidateCode === 'string') {
    return candidateCode;
  }
  return '';
}

function mapHttpStatusToErrorCode(httpStatus: number): string {
  if (httpStatus === 401) {
    return 'UNAUTHORIZED';
  }
  if (httpStatus === 403) {
    return 'FORBIDDEN';
  }
  if (httpStatus === 404) {
    return 'NOT_FOUND';
  }
  if (httpStatus === 400 || httpStatus === 422) {
    return 'VALIDATION_ERROR';
  }
  if (httpStatus >= 500) {
    return 'SERVER_ERROR';
  }
  return '';
}

export function resolveApiErrorTranslationKey(caughtError: unknown): string {
  if (axios.isAxiosError(caughtError) === false) {
    return 'errors:generic';
  }
  if (caughtError.response === undefined) {
    return 'errors:network';
  }

  const backendErrorCode = readBackendErrorCode(caughtError.response.data);
  const isKnownBackendCode = KNOWN_ERROR_CODES.some(function matchesBackendCode(knownCode) {
    return knownCode === backendErrorCode;
  });
  if (isKnownBackendCode === true) {
    return buildErrorCodeTranslationKey(backendErrorCode);
  }

  const statusErrorCode = mapHttpStatusToErrorCode(caughtError.response.status);
  if (statusErrorCode.length > 0) {
    return buildErrorCodeTranslationKey(statusErrorCode);
  }

  return 'errors:generic';
}
